import { APP_CONFIG } from '@core/configs';
import { environment } from '@environments/environment';
import { update } from 'lodash';

// export const API_BASE_URL = APP_CONFIG.apiBaseUrl;
export const API_BASE_URL = environment.CLIENT_API;
export const TOKEN_URL = APP_CONFIG.tokenUrl;
export const API_TOKEN_URL = environment.API_TOKEN_URL;
export const REFRESH_TOKEN_URL = environment.REFRESH_TOKEN;

export const API_ENDPOINT = {
  authConsole: {
    base: API_BASE_URL + 'auth',
    refreshToken: API_BASE_URL + 'auth/refresh',
    logout: API_BASE_URL + 'auth/logout',
    login: API_BASE_URL + 'auth/login',
    loginByToken: API_BASE_URL + 'auth/login-by-token',
    get_organizations: API_BASE_URL + 'corp/get-organizations',
    checkResourcePolicy: API_BASE_URL + 'resource-policy/check-resource-policy',
    getAllCorp: API_BASE_URL + 'corp/get-all-corp',
    getAllOrgMapInfo: API_BASE_URL + 'corp/get-all-map-info',
    getListMapInfo: API_BASE_URL + 'corp/get-list-map-info',
    updateMapRowData: API_BASE_URL + 'corp/update-map-info',
    updateMapDetailInfo: API_BASE_URL + 'corp/update-map-detail',
    createMap: API_BASE_URL + 'corp/create-map-info',
    getBusinessMapping: API_BASE_URL + 'corp/get-business-mapping',
    deleteMapRowData: API_BASE_URL + 'corp/delete-map-info',
    syncMapInfoData: API_BASE_URL + 'corp/sync-map-data',
    getOfficeByOrganizationIds: API_BASE_URL + 'migration/get-offices-by-organization-ids',
    //updateDynamoDB: API_BASE_URL + 'corp/set-offices-info',
    updateDynamoDB: API_BASE_URL + 'corp/set-map-company-info',
    setForceLogoutVersionByOffice: API_BASE_URL + 'corp/set-force-logout-version-by-office',
  }
};

export const TOKEN_API_ENDPOINT = {
  login: API_TOKEN_URL + "/user/login",
  refreshToken: API_TOKEN_URL + "/ck-pass/token/refresh",
  verifyRefreshToken: API_TOKEN_URL + "/ck-pass/token/verify-refresh-token",
  logout: API_TOKEN_URL + "/token/logout",
};